import HttpRequest from './http_request'

class PrintProvider extends HttpRequest {
  constructor () {
    super(`${process.env.PRINT_API}/public/5e3548c2d32cb12606a34fb8`)
  }

  async getPrinters (branchId) {
    const { data } = await this.get(`/printers/${branchId}`)
    return data
  }

  async printReceipt (payload) {
    const { data } = await this.create(`/prints/receipt`, payload)
    return data
  }

  async printReportZ (payload) {
    const { data } = await this.create(`/prints/report-z`, payload)
    return data
  }
}

export default PrintProvider



// WEBPACK FOOTER //
// ./src/resources/print_provider.js